<template>
  <v-container class="pa-0"  fluid>
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1">{{ $t('Gautų dokumentų žurnalas') }}</h1>
    <!-- search -->
    <admin-journal-received-search
      :loading="loading"
      @search="searchInstitutions"
      @downloadReport="downloadReport"
    />
    <el-simple-table class="pb-3" leftWidth="21rem" :items="mainDataList" />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :item-class="rowClass"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal')
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->
      <template #[`item.status`]="{ item }">
        <el-table-enum enumName="journalType" :item="item.status.toString()" />
      </template>
      <template #[`item.receive_mode`]="{ item }">
        <el-table-enum enumName="receiveMode" :item="item.receive_mode.toString()" />
      </template>
      <!--main custom templates -->
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="item"
            handling
            @editItem="editItem(item)"
            @viewItem="viewItem(item)"
            @deleteItem="deleteItem(item)"
            @restoreItem="restoreItem(item)"
          />
        </div>
      </template>
      <template #[`item.in_journal_type`]="{ item }">
        <el-table-enum enumName="inJournalType" :item="item.in_journal_type" />
      </template>
      <template #[`item.data_provider_type`]="{ item }">
        <el-table-enum enumName="dataProviderType" :item="item.data_provider_type" />
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <modal-delete
      title="Šalinti įrašą"
      text="Ar tikrai norite pašalinti įrašą?"
      v-model="showDelete"
      :loading="loading"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import AdminJournalReceivedSearch from './AdminJournalReceivedSearch'
import userRole from '@/mixins/userRole'
import ModalDelete from '@/components/modals/ModalDelete'
import tableParameters from '@/mixins/tableParameters'
import math from '@/mixins/math'

export default {
  name: 'JournalReceived',
  components: {
    AdminJournalReceivedSearch,
    ModalDelete,
  },
  mixins: [userRole, tableParameters, math],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      showDelete: false,
      modalDeleteItem: null,
      listData: [],
      searchData: {},
      notSolvedCounts: [],

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    mainDataList(){
      return [
        {
          title: this.$t('Nesutvarkyti pranešimai'),
          value: this.notSolvedCounts.total
        },
        {
          title: this.$t('Pranešimai, kurių tvarkymo terminas baigiasi'),
          value: this.notSolvedCounts.blue
        },
        {
          title: this.$t('Pranešimai, kurių tvarkymo terminas praleistas'),
          value: this.notSolvedCounts.red
        }
      ]
    },
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
        },
        {
          text: this.$t('Reg. Nr. gautų dokumentų žurnale'),
          align: 'start',
          value: 'document_no',
          width: '8rem',
        },
        {
          text: this.$t('Gauto dokumento pavadinimas'),
          align: 'start',
          value: 'in_journal_type',
        },
        {
          text: this.$t('Gavimo būdas'),
          align: 'start',
          value: 'receive_mode',
           width: '5rem',
        },
        {
          text: this.$t('Gavimo data ir laikas'),
          align: 'start',
          value: 'date_received',
          width: '8rem',
        },
        {
          text: this.$t('Identifikavimo kodas'),
          align: 'start',
          value: 'code',
          width: '8rem',
        },
        {
          text: this.$t('Duomenų teikėjas'),
          align: 'start',
          value: 'data_provider',
        },
             {
          text: this.$t('Duomenų teikėjo tipas'),
          align: 'start',
          value: 'data_provider_type',
          enumName : 'dataProviderType',
        },
        {
          text: this.$t('Pranešimo būsena'),
          align: 'start',
          value: 'status',
           width: '6rem',
        },
        {
          text: this.$t('Būsenos data'),
          align: 'start',
          value: 'status_date',
          width: '6.6rem',
        },
         {
          text: this.$t('Reg. Nr. nepatikrintų dokumentų žurnale'),
          align: 'start',
          value: 'ns_gdz',
          width: '6.6rem',
        },
      ]
    },

    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  beforeDestroy() {},
  created() {
    // this.setlistParams()
  },
  methods: {
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }

      this.setSortParams()
      
      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`in-journals/list`, data)
        .then((res) => {
          this.listData = res.data.inJournals
          this.pagination = { ...this.pagination, ...res.data.pagination }
          this.notSolvedCounts = res.data.not_solved
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
          page: pagination.page,
          route: this.$route.name,
      })     
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchInstitutions(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(searchData.btn)
    },

    viewItem(item, mode) {
      this.$router.push({
        name: 'adminJournalReceivedForm',
        params: {
          id: item.id,
        },
      })
    },
    editItem(item, mode) {
      this.$router.push({
        name: 'adminJournalReceivedForm',
        params: {
          id: item.id,
        },
      })
    },

    deleteItem(item) {
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },

    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`in-journals/${item.id}`)
        .then((res) => {
          this.$root.$emit('DATA_OK_CODE', '000111')
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.showDelete = false
        })
    },
    openFile(file) {
      var fileLink = document.createElement('a')
      fileLink.href = file.file
      fileLink.setAttribute(
        'download',
        this.safeFileName(file.original_filename)
      )
      document.body.appendChild(fileLink)
      fileLink.click()
    },
    downloadReport() {
      this.loading = true
      const data = {
        ...this.pagination,
        search: this.searchData,
        isReport: true,
      }
      this.$axios
        .post(`in-journals/list`, data)
        .then((res) => {
           this.openFile(res.data)
        })
        .catch((err) => {
          const errData = JSON.parse(
            Buffer.from(err.response.data).toString('utf8')
          )
          this.$root.$emit('DATA_ERROR', errData.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    rowClass(item) {
      if (item.rowColor == 'row-blue') {
        return `row-blue`
      }
      if (item.rowColor == 'row-red') {
        return `row-red`
      }
      return ''
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>
